class ProductBundleButtons extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.product-description-bundles__product')
    this.contentContainer = this.querySelector('.product-description-bundles__tabs-container');

    this.buttons.forEach(el => {
      el.addEventListener('click', () => {
        this.handleButtonClick(el.getAttribute('prod-handle'))
        this.removeActiveClass()
        el.classList.add('active')
      })
    })
  }

  removeActiveClass() {
    this.buttons.forEach(el => {
      el.classList.remove('active')
    })
  }

  // Handle button click and fetch Shopify section
  async handleButtonClick(handle) {

    // get current height
    if (!handle) {
      this.displayError('Product handle is missing');
      return;
    }

    this.contentContainer.parentElement.style.minHeight = `${this.contentContainer.clientHeight}px`

    this.contentContainer.innerHTML = '<p class="loading">Loading...</p>';

    try {
      // Call Shopify Sections API
      const response = await fetch(`/products/${handle}?section_id=product-bundle-tabs`, {
        headers: {
          'Accept': 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch section');
      }

      this.contentContainer.parentElement.style.minHeight = 'unset'

      const html = await response.text();
      // Render the section content
      this.contentContainer.innerHTML = html;
    } catch (error) {
      this.displayError('Failed to load product bundle section');
      console.error('Error fetching section:', error);
    }
  }

  // Display error message
  displayError(message) {
    this.contentContainer.innerHTML = `<p class="error">${message}</p>`;
  }
}

// Define the custom element
customElements.define('pl-product-bundle-tabs-swap', ProductBundleButtons);